(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sfp-arrival-estimate"] && !Shopify.designMode) return;
  try {
    class SfpArrivalEstimate extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.button = this.querySelector('button');
      this.result = this.querySelector('[role="status"]');
      this.labels = JSON.parse(this.querySelector('[data-eta-labels]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-eta-variants]').textContent);
      this.life = new AbortController();
      this.button.addEventListener('click', () => this.check(), { signal:this.life.signal });
      this.input.addEventListener('keydown', e => { if(e.key === 'Enter') { e.preventDefault(); this.check(); } }, { signal:this.life.signal });
      this.input.addEventListener('input', () => { this.request?.abort(); this.result.textContent=''; }, { signal:this.life.signal });
      this.onChange = e => { if(!this.contains(e.target)) { clearTimeout(this.timer); this.timer=setTimeout(() => { if(this.place) this.renderEstimate(); },400); } };
      this.closest('.shopify-section')?.addEventListener('change', this.onChange, { signal:this.life.signal });
      try { this.input.value=sessionStorage.getItem('sfp-delivery-zip') || ''; } catch {}
      if(this.input.value) this.check();
    }
    disconnectedCallback() { this.life?.abort(); this.request?.abort(); clearTimeout(this.timer); }
    async check() {
      const zip=this.input.value.trim();
      this.request?.abort(); this.place=null;
      if(!/^\d{5}$/.test(zip)) { this.result.textContent=this.labels.invalid; return; }
      this.request=new AbortController(); const request=this.request;
      this.result.textContent=this.labels.loading; this.button.disabled=true;
      const timeout=setTimeout(()=>request.abort(),8000);
      try {
        const response=await fetch('https://api.zippopotam.us/us/'+encodeURIComponent(zip),{signal:request.signal,credentials:'omit',referrerPolicy:'no-referrer'});
        if(response.status===404) { this.result.textContent=this.labels.invalid; return; }
        if(!response.ok) throw new Error('lookup');
        const data=await response.json();
        if(this.input.value.trim()!==zip) return;
        const place=data.places?.[0]; if(!place) throw new Error('lookup');
        this.place={zip,city:place['place name'],state:place['state abbreviation']};
        try { sessionStorage.setItem('sfp-delivery-zip',zip); } catch {}
        this.renderEstimate();
      } catch { if(this.request===request && this.input.value.trim()===zip) this.result.textContent=this.labels.error; }
      finally { clearTimeout(timeout); if(this.request===request) this.button.disabled=false; }
    }
    renderEstimate() {
      if(!this.place) return;
      const form=this.closest('.shopify-section')?.querySelector('form[action*="/cart/add"] input[name="id"]');
      const id=form?.value || this.dataset.selected;
      if(this.variants[id]===false) { this.result.textContent=this.labels.unavailable; return; }
      if(this.dataset.special==='true') { this.result.textContent=this.labels.special; return; }
      const states='AL AZ AR CA CO CT DE DC FL GA ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(' ');
      if(!states.includes(this.place.state)) { this.result.textContent=this.labels.outside; return; }
      const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
      const part=t=>Number(parts.find(p=>p.type===t).value);
      const today=new Date(Date.UTC(part('year'),part('month')-1,part('day'),12));
      const windowDays=this.dataset.essentials==='true'?[5,7]:[7,10];
      const start=this.addDays(today,windowDays[0]),end=this.addDays(today,windowDays[1]);
      const format=new Intl.DateTimeFormat(document.documentElement.lang || 'en-US',{timeZone:'UTC',month:'short',day:'numeric',year:start.getUTCFullYear()!==today.getUTCFullYear()?'numeric':undefined});
      this.result.replaceChildren();
      const label=document.createElement('div');label.textContent=this.labels.arrival;
      const dates=document.createElement('strong');dates.textContent=format.format(start)+' – '+format.format(end);
      const location=document.createElement('span');location.textContent=this.labels.destination+' '+this.place.city+', '+this.place.state+' '+this.place.zip;
      this.result.append(label,dates,location);
    }
    addDays(from,count) {
      const d=new Date(from);let n=0;
      while(n<count) { d.setUTCDate(d.getUTCDate()+1); if(d.getUTCDay()!==0 && d.getUTCDay()!==6 && !this.holiday(d)) n++; }
      return d;
    }
    holiday(d) {
      const y=d.getUTCFullYear(),key=d.toISOString().slice(0,10),dates=[];
      const fixed=(year,m,day)=>{ const x=new Date(Date.UTC(year,m,day,12)); if(x.getUTCDay()===6)x.setUTCDate(x.getUTCDate()-1); if(x.getUTCDay()===0)x.setUTCDate(x.getUTCDate()+1); dates.push(x.toISOString().slice(0,10)); };
      const nth=(m,weekday,n)=>{ const x=new Date(Date.UTC(y,m,1,12)); x.setUTCDate(1+(weekday-x.getUTCDay()+7)%7+(n-1)*7); dates.push(x.toISOString().slice(0,10)); };
      [y-1,y,y+1].forEach(year=>{ fixed(year,0,1);fixed(year,5,19);fixed(year,6,4);fixed(year,10,11);fixed(year,11,25); });
      nth(0,1,3);nth(1,1,3);nth(8,1,1);nth(9,1,2);nth(10,4,4);
      const may=new Date(Date.UTC(y,5,0,12));may.setUTCDate(may.getUTCDate()-(may.getUTCDay()+6)%7);dates.push(may.toISOString().slice(0,10));
      return dates.includes(key);
    }
  }
  if(!customElements.get('sfp-arrival-estimate')) customElements.define('sfp-arrival-estimate',SfpArrivalEstimate);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sfp-offer-arrival"] && !Shopify.designMode) return;
  try {
    class SfpOfferArrival extends HTMLElement {
    connectedCallback() {
      this.life?.abort();
      this.input = this.querySelector('input');
      this.note = this.querySelector('[data-eta-note]');
      this.button = this.querySelector('button');
      this.result = this.querySelector('[role="status"]');
      this.labels = JSON.parse(this.querySelector('[data-eta-labels]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-eta-variants]').textContent);
      this.life = new AbortController();
      this.button.addEventListener('click', () => this.check(), { signal:this.life.signal });
      this.input.addEventListener('keydown', e => { if(e.key === 'Enter') { e.preventDefault(); this.check(); } }, { signal:this.life.signal });
      this.input.addEventListener('input', () => { this.request?.abort(); this.request=null; this.place=null; this.result.textContent=''; this.note.hidden=true; this.button.disabled=false; this.input.removeAttribute('aria-invalid'); }, { signal:this.life.signal });
      this.onChange = e => { if(!this.contains(e.target)) { clearTimeout(this.timer); this.timer=setTimeout(() => { if(this.place) this.renderEstimate(); },400); } };
      this.closest('.shopify-section')?.addEventListener('change', this.onChange, { signal:this.life.signal });

    }
    disconnectedCallback() { this.life?.abort(); this.request?.abort(); clearTimeout(this.timer); }
    async check() {
      const zip=this.input.value.trim();
      this.request?.abort(); this.request=null; this.place=null; this.note.hidden=true; this.button.disabled=false;
      if(!/^\d{5}$/.test(zip)) { this.input.setAttribute('aria-invalid','true'); this.result.textContent=this.labels.invalid; return; }
      this.input.removeAttribute('aria-invalid');
      this.request=new AbortController(); const request=this.request;
      this.result.textContent=this.labels.loading; this.button.disabled=true;
      const timeout=setTimeout(()=>request.abort(),8000);
      try {
        const response=await fetch('https://api.zippopotam.us/us/'+encodeURIComponent(zip),{signal:request.signal,credentials:'omit',referrerPolicy:'no-referrer'});
        if(this.request!==request || this.input.value.trim()!==zip) return;
        if(response.status===404) { this.result.textContent=this.labels.invalid; return; }
        if(!response.ok) throw new Error('lookup');
        const data=await response.json();
        if(this.request!==request || this.input.value.trim()!==zip) return;
        const place=data.places?.[0]; if(!place) throw new Error('lookup');
        this.place={zip,city:place['place name'],state:place['state abbreviation']};
        this.renderEstimate();
      } catch { if(this.request===request && this.input.value.trim()===zip) this.result.textContent=this.labels.error; }
      finally { clearTimeout(timeout); if(this.request===request) this.button.disabled=false; }
    }
    renderEstimate() {
      if(!this.place) return;
      if(this.input.value.trim()!==this.place.zip) return;
      this.note.hidden=true;
      const form=document.getElementById(this.dataset.formId);
      const selected=form?.querySelector('input[name="id"]:checked,select[name="id"],input[type="hidden"][name="id"]');
      const firstAvailable=Object.keys(this.variants).find(key=>this.variants[key]);
      const id=selected?.value || firstAvailable;
      if(!id) { this.result.textContent=this.labels.unavailable; return; }
      const standard=this.dataset.essentials==='true'?[5,7]:[7,10];
      const [min,max]=this.dataset.verified==='true'?[Number(this.dataset.min),Number(this.dataset.max)]:standard;
      if(!Number.isInteger(min) || !Number.isInteger(max) || min<1 || max<min || max>30) { this.result.textContent=this.labels.unverified; return; }
      if(this.variants[id]===false) { this.result.textContent=this.labels.unavailable; return; }
      if(this.dataset.special==='true') { this.result.textContent=this.labels.special; return; }
      const states='AL AZ AR CA CO CT DE DC FL GA ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(' ');
      if(!states.includes(this.place.state)) { this.result.textContent=this.labels.outside; return; }
      const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
      const part=t=>Number(parts.find(p=>p.type===t).value);
      const today=new Date(Date.UTC(part('year'),part('month')-1,part('day'),12));
      const windowDays=[min,max];
      const start=this.addDays(today,windowDays[0]),end=this.addDays(today,windowDays[1]);
      const format=new Intl.DateTimeFormat(document.documentElement.lang || 'en-US',{timeZone:'UTC',month:'short',day:'numeric',year:start.getUTCFullYear()!==today.getUTCFullYear()?'numeric':undefined});
      this.result.replaceChildren();
      const label=document.createElement('div');label.textContent=this.labels.arrival;
      const dates=document.createElement('strong');dates.textContent=format.format(start)+' – '+format.format(end);
      const location=document.createElement('span');location.textContent=this.labels.destination+' '+this.place.city+', '+this.place.state+' '+this.place.zip;
      this.result.append(label,dates,location);
      this.note.textContent=this.note.dataset.template.replace('[min]',min).replace('[max]',max);
      this.note.hidden=false;
    }
    addDays(from,count) {
      const d=new Date(from);let n=0;
      while(n<count) { d.setUTCDate(d.getUTCDate()+1); if(d.getUTCDay()!==0 && d.getUTCDay()!==6 && !this.holiday(d)) n++; }
      return d;
    }
    holiday(d) {
      const y=d.getUTCFullYear(),key=d.toISOString().slice(0,10),dates=[];
      const fixed=(year,m,day)=>{ const x=new Date(Date.UTC(year,m,day,12)); if(x.getUTCDay()===6)x.setUTCDate(x.getUTCDate()-1); if(x.getUTCDay()===0)x.setUTCDate(x.getUTCDate()+1); dates.push(x.toISOString().slice(0,10)); };
      const nth=(m,weekday,n)=>{ const x=new Date(Date.UTC(y,m,1,12)); x.setUTCDate(1+(weekday-x.getUTCDay()+7)%7+(n-1)*7); dates.push(x.toISOString().slice(0,10)); };
      [y-1,y,y+1].forEach(year=>{ fixed(year,0,1);fixed(year,5,19);fixed(year,6,4);fixed(year,10,11);fixed(year,11,25); });
      nth(0,1,3);nth(1,1,3);nth(8,1,1);nth(9,1,2);nth(10,4,4);
      const may=new Date(Date.UTC(y,5,0,12));may.setUTCDate(may.getUTCDate()-(may.getUTCDay()+6)%7);dates.push(may.toISOString().slice(0,10));
      return dates.includes(key);
    }
  }
  if(!customElements.get('sfp-offer-arrival')) customElements.define('sfp-offer-arrival',SfpOfferArrival);
  } catch(e) { console.error(e); }
})();

})();
